import api from "../api/axiosInstance";

const emailLogService = {
    getAll: (params) => api.get("/email-logs", { params }),
    getOne: (id) => api.get(`/email-logs/${id}`),
};

export default emailLogService;